
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class IcStockSoldDialog extends Serenity.EntityDialog<IcStockSoldRow, any> {
        protected getFormKey() { return IcStockSoldForm.formKey; }
        protected getIdProperty() { return IcStockSoldRow.idProperty; }
        protected getLocalTextPrefix() { return IcStockSoldRow.localTextPrefix; }
        protected getNameProperty() { return IcStockSoldRow.nameProperty; }
        protected getService() { return IcStockSoldService.baseUrl; }
        protected getDeletePermission() { return IcStockSoldRow.deletePermission; }
        protected getInsertPermission() { return IcStockSoldRow.insertPermission; }
        protected getUpdatePermission() { return IcStockSoldRow.updatePermission; }

        protected form = new IcStockSoldForm(this.idPrefix);
        constructor() {
            super();

            this.form = new IcStockSoldForm(this.idPrefix);
            this.form.PostFg.element.parent();
            (this.form.SoldDtList.view as any).onDataChanged.subscribe(() => {
                let self = this;
                //ui-state-default slick-footerrow-column l0 r0 frozen
                self.element.find(".ui-state-default.slick-footerrow-column.l0.r0.frozen").html("รวม");
            });
        }
        protected initToolbar() {
            super.initToolbar();

        }
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            if (this.isEditMode) {
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
                let newSavePosBtn: Serenity.ToolButton =
                {
                    title: "POST",
                    hint: "Post and Save",
                    separator: false,
                    cssClass: "button-save-post",
                    icon: "fa fa-save",
                    hotkey: 'alt+shift+s',
                    onClick: (e) => {
                        var self = this;
                        if (this.validateForm() && this.validateBeforeSave()) {
                            var options = this.getSaveOptions((response) => {

                                if (this.isEditMode()) {
                                    var id1 = response.EntityId;
                                    if (id1 == null) {
                                        id1 = this.get_entityId();
                                    }
                                    var a = this.loadById(id1);
                                }
                                else {
                                    var a = this.loadById(response.EntityId);
                                }
                                
                                // this.showSaveSuccessMessage(response);
                                Q.confirm('ยืนยันการบันทึกเอกสาร POST', () => {
                                    this.form.PostFg.value = "3";
                                    this.form.PostFg.forceUpdate();
                                    this.save((response1) => {
                                        this.dialogClose();
                                    });
                                });

                            });

                            options.onError = function (response) {
                                Q.alert(response.Error.Message);

                            }

                            Q.serviceCall(options);
                        }




                    }
                };
                buttons.push(newSavePosBtn);
                let newSaveBtn: Serenity.ToolButton =
                {
                    title: "บันทึกเอกสาร แต่ยังไม่ POST",
                    hint: "Save",
                    separator: false,
                    cssClass: "button-save",
                    icon: "fa fa-save",
                    hotkey: 'alt+s',
                    onClick: (e) => {

                        var self = this;


                        if (this.validateForm() && this.validateBeforeSave()) {
                            var options = this.getSaveOptions((response) => {

                                if (this.isEditMode()) {
                                    var id1 = response.EntityId;
                                    if (id1 == null) {
                                        id1 = this.get_entityId();
                                    }
                                    this.loadById(id1);
                                }
                                else {
                                    // this.loadById(response.EntityId);
                                    this.dialogClose();
                                }

                                this.showSaveSuccessMessage(response);


                            });

                            options.onError = function (response) {
                                if (response.Error.Message == "Can't save record. There is another record with the same เลขที่เอกสาร value!") {
                                    Q.alert(response.Error.Message = "เลขที่เอกสารถูกใช้งานแล้ว ระบบจำทำการบรับเลขที่เอกสาร โปรดทำการบันทึกอีกครั้ง");
                                    var s = self.form.SysDocNo.value
                                    var f = s.substring(0, 9)
                                GeniuzPOS.Inventory.IcStockSoldService.GetNextNumber({
                                    Prefix: f,
                                    Length: 15
                                }, response => {

                                    self.form.SysDocNo.value = response.Serial;

                                });
                            } else { Q.alert(response.Error.Message); }



                        }

                        Q.serviceCall(options);
                    } else {
                        this.save((response) => {
                            this.dialogClose();
                        });


                    }

                    }
                };
                buttons.push(newSaveBtn);
                let newDeleteBtn: Serenity.ToolButton =
                {
                    title: "ลบเอกสาร'",
                    hint: "Delete",
                    separator: false,
                    cssClass: "delete-button",
                    icon: "fa fa-save",
                    hotkey: 'alt+x',
                    onClick: (e) => {
                        Q.confirm('ยืนยันการลบเอกสาร', () => {
                            this.form.CancelFg.value = "2";                                
                            this.save((response) => {
                                this.dialogClose();
                            });
                        });
                    }
                };
                buttons.push(newDeleteBtn);
                

            }
            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();
     
                    },
                }
            );

            return buttons;
        }
        // protected beforeLoadEntity() {
        //     let self = this;
        //     // self.toolbar.findButton('save-and-close-button').text('บันทึกเอกสาร');
        //     // self.toolbar.findButton('delete-button').text('ลบเอกสาร');

        //     //this.form.ReceiveDtList.myPassValue = this.entity.SysDocNo
        //     //if (this.isNew()) {
        //     //    this.getNextNumber();
        //     //}

        // }
        protected afterLoadEntity() {
            super.afterLoadEntity();

            this.form.SoldDtList.myPassValue = this.entity.SysDocNo
            if (this.entity.PostFg == 1) {
                this.form.SoldDtList.myPassValue2 = this.entity.PostFg;
            } else {
                this.form.SoldDtList.myPassValue2 = 0;
            }
            if (this.isNew()) {
                this.getNextNumber();
                this.toolbar.findButton('button-save-post').hide();
                this.toolbar.findButton('delete-button').hide();
            }

            ////----
            let self = this;
            let nbrRetry = 0;
            (function changeTitle() {
                if (nbrRetry >= 10) {
                    return;
                }

                setTimeout(() => {
                    if ((self as any).isMarkedAsPanel === true) {
                        if (self.element.find(".panel-titlebar").length == 1) {
                            // self.element.find(".panel-titlebar").html("");
                            // self.element.find(".panel-titlebar-text").html("");
                            self.element.find(".panel-titlebar-close").html("");//panel-titlebar
                        }
                        else {
                            changeTitle();
                        }
                    }
                    else {
                        if (self.element.parent().find(".panel-titlebar").length == 1) {
                            // self.element.parent().find(".panel-titlebar").html("");
                            // self.element.parent().find(".panel-titlebar-text").html("");
                            self.element.parent().find(".panel-titlebar-close").html("");
                        }
                        else {
                            changeTitle();
                        }
                    }
                }, 100);
            })();
            if (this.entity.PostFg == 1 || this.entity.PostFg == 2 || this.entity.CancelFg== 1) {
                this.toolbar.findButton('creates-followup-button').hide();
                this.toolbar.findButton('genarate-po-button').hide();
                this.toolbar.findButton('button-save-post').hide();
                this.toolbar.findButton('button-save').hide();
                this.toolbar.findButton('apply-changes-button').toggleClass('disabled', false);
                //Serenity.EditorUtils.setReadonly(this.element.find('.editor'), true);
               // this.applyChangesButton.toggleClass('disabled', true);
               // this.saveAndCloseButton.toggleClass('disabled', true);
                this.deleteButton.toggleClass('disabled', true);
                this.form.SoldDtList.set_readOnly(true);
            } else {
                this.toolbar.findButton('apply-changes-button').hide();

            }
        }
    
        protected getSaveEntity(): IcStockSoldRow {
            let entity = super.getSaveEntity();

            return entity;
        }
        

        private getNextNumber() {
            var val = Q.trimToNull(this.form.SysDocNo.value);
            
     

            if (!val || val.length <= 3) {
                var someDate = new Date();
                var dd = someDate.getDate();
                var mm = someDate.getMonth() + 1;
                var myRow = 0;
                var userId = Q.first(Administration.UserRow.getLookup().items, x => x.ShopId == Authorization.userDefinition.ShopId);
                 console.log('User Id : ' + userId.ShopId);
                 try {
                var userRole = Q.first(Administration.UserRoleRow.getLookup().items, x => x.UserId == userId.UserId);

                if (userRole != null) {
                    myRow = userRole.RoleId;
                }
                if (userRole != null || userRole.RoleId.valueOf) {
                    myRow = userRole.RoleId;
                }
                if (myRow == 1) {
                    //(this.form.SlmnCode.element as any).select2(userId.SlmnCode);
                }
                } catch {

                }
             
                var y = someDate.getFullYear();
                var mo = "";
                var ddd = "";

                if (mm < 10) {
                    mo = '0' + mm;

                } else {
                    mo = mm.toString();
                }

                if (dd < 10) {
                    //ddd = '0' + dd;
                    ddd = '';

                } else {
                    //ddd = dd.toString();
                    ddd = '';
                }

                var someFormattedDate = y.toString().substr(2, 2);
                
                var docprefix = Q.tryFirst(Product.CsDocTypeRow.getLookup().items, x => x.DocType == "33").DocPrefix;
                var prefix = docprefix + userId.ShopId  + someFormattedDate + mo + ddd ;
                GeniuzPOS.Inventory.IcStockSoldService.GetNextNumber({
                    Prefix: prefix,
                    Length: 15
                }, response => {

                    this.form.SysDocNo.value = response.Serial;
                    this.form.DocDate.element.focus();
                });
            }

        }

  
    }
}